var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStepExecutionsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 38.119,
    height: 27.885,
    viewBox: "0 0 38.119 27.885",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2202",
    "data-name": "Group 2202",
    transform: "translate(-107.928 -1384.65)",
    fill: "white"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2196",
    "data-name": "Group 2196",
    transform: "translate(373 1260.373)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2195",
    "data-name": "Group 2195",
    transform: "translate(-251 128)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_288",
    "data-name": "Path 288",
    d: "M17.558,5H11l7.287,10.2L11,25.4h6.558l7.287-10.2Z",
    transform: "translate(-0.798 -5)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2201",
    "data-name": "Group 2201",
    transform: "translate(107.928 1384.65)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_290",
    "data-name": "Path 290",
    d: "M0,0H27.885V27.885H0Z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_291",
    "data-name": "Path 291",
    d: "M14.633,3A10.226,10.226,0,0,0,4.408,13.225H1l4.419,4.419.08.159,4.59-4.578H6.68a7.991,7.991,0,1,1,2.34,5.612L7.408,20.45A10.222,10.222,0,1,0,14.633,3ZM13.5,8.68v5.68l4.862,2.886.818-1.375L15.2,13.509V8.68Z",
    transform: "translate(0.239 0.718)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStepExecutionsIcon);
export default __webpack_public_path__ + "static/media/Step-Executions-Icon.e4a672fd28bd4e6eb6dd055663e9d452.svg";
export { ForwardRef as ReactComponent };